import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RelapseService } from '@app/tvf/relapse/services/relapse.service';
import Utils from '@app/shared/utils/utils';

@Component({
  selector: 'app-dialog-laudo-b2b',
  templateUrl: './dialog-laudo-b2b.component.html',
  styleUrls: ['./dialog-laudo-b2b.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class DialogLaudoB2bComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogLaudoB2bComponent>,
    private toastr: ToastrService,
    private relapseService: RelapseService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  reportForm!: FormGroup;
  trades: any[] = [];
  trade!: any;
  currentIndex = 1;
  reportCount = 0;
  reportsData: any[] = [];
  isSubmitting = false;
  isLoadingTrade = true;

  get progressPercent(): string {
    if (this.reportCount === 0) return '0%';
    return `${(this.currentIndex / this.reportCount) * 100}%`;
  }

  ngOnInit(): void {
    const initialTrades = this.data?.trades || [];
    this.reportCount = initialTrades.length;
    this.currentIndex = 1;

    const tradesId = initialTrades.map((t: any) => t.tradeId);
    this.relapseService.getLaudoB2B(tradesId).subscribe({
      next: (res) => {
        this.trades = res?.data || res || [];
        this.reportCount = this.trades.length;
        this.isLoadingTrade = false;
        this.setCurrentTrade();
      },
      error: (err) => {
        console.error('B2B laudo error:', err);
        this.isLoadingTrade = false;
      },
    });

    this.reportForm = this.fb.group({
      salesInvoices: ['', [Validators.required, Validators.maxLength(500)]],
      returnInvoice: ['', [Validators.required, Validators.maxLength(500)]],
      customer: ['', [Validators.required, Validators.maxLength(200)]],
      finalResult: ['', [Validators.required, Validators.maxLength(500)]],
      contestationReason: ['', [Validators.required, Validators.maxLength(500)]],
    });
  }

  setCurrentTrade(): void {
    const selected = this.trades[this.currentIndex - 1];
    this.trade = {
      sku: selected?.sku || '',
      product: selected?.productDescription || selected?.produto || '',
      idTrade: selected?.tradeId || '',
      imei: selected?.imei || '',
      assessmentDate: selected?.date || selected?.relapseDate || '',
      classification: selected?.classification || selected?.status || '',
      defects: selected?.customerDefects || selected?.defeitos || '',
      defectsConfirmed: selected?.validatedDefects || selected?.defeitosProcedem || '',
    };
  }

  onClienteInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(/[^a-zA-ZÀ-ÿ ]/g, '');
    const titled = cleaned.split(' ').map(w => w.length ? w[0].toUpperCase() + w.slice(1) : '').join(' ');
    input.value = titled;
    this.reportForm.get('customer')?.setValue(titled);
  }

  onAlphanumericInput(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    input.value = cleaned;
    this.reportForm.get(controlName)?.setValue(cleaned);
  }

  onSalesInvoicesInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(/[^a-zA-Z0-9,\s]/g, '').replace(/(?<!,)\s/g, '').toUpperCase();
    input.value = cleaned;
    this.reportForm.get('salesInvoices')?.setValue(cleaned);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (this.reportForm.invalid || this.isSubmitting) return;

    this.reportsData.push({
      tradeId: this.trade.idTrade,
      contestationReason: this.reportForm.get('contestationReason')?.value,
    });

    if (this.currentIndex < this.reportCount) {
      this.reportForm.patchValue({ contestationReason: '' });
      this.reportForm.get('contestationReason')?.markAsUntouched();
      this.reportForm.get('contestationReason')?.markAsPristine();

      this.currentIndex++;
      this.setCurrentTrade();
    } else {
      this._sendReport();
    }
  }

  private _sendReport(): void {
    this.isSubmitting = true;

    const salesInvoicesRaw: string = this.reportForm.get('salesInvoices')?.value || '';
    const invoiceNumberList = salesInvoicesRaw
      .split(',')
      .map((s: string) => s.trim())
      .filter((s: string) => s.length > 0);

    const payload = {
      invoiceNumberList,
      returnNoteNumber: this.reportForm.get('returnInvoice')?.value || '',
      custumer: this.reportForm.get('customer')?.value || '',
      finalResult: this.reportForm.get('finalResult')?.value || '',
      laudos: this.reportsData,
    };

    this.relapseService.sendLaudoB2B(payload).subscribe({
      next: (res: Blob) => {
        this.isSubmitting = false;
        this.toastr.success('Laudo B2B emitido com sucesso!');
        if (res) {
          Utils.createAndDownloadBlobFile(res, 'Laudo_B2B', 'pdf');
        }
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isSubmitting = false;
        this.toastr.error('Erro ao emitir laudo B2B. Tente novamente.');
        console.error(err);
      },
    });
  }
}
